import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const CashbacksContext = createContext();

export const useCashbacks = () => {
    const context = useContext(CashbacksContext);
    if (!context) {
        throw new Error('useCashbacks must be used within a CashbacksProvider');
    }
    return context;
};

export const CashbacksProvider = ({ children }) => {
    const [pendingCount, setPendingCount] = useState(0);
    const { user } = useAuth();

    const fetchPendingCount = async () => {
        try {
            const response = await fetch("https://us-central1-workexpress-1ffff.cloudfunctions.net/app/cashback");
            
            // Handle 404 - endpoint not deployed yet or collection doesn't exist
            if (response.status === 404) {
                setPendingCount(0);
                return;
            }

            if (!response.ok) {
                // Only log if it's not a 404 (which we handle above)
                if (response.status !== 404) {
                    console.warn('Failed to fetch cashbacks count:', response.status, response.statusText);
                }
                return;
            }

            const data = await response.json();
            const cashbacks = data.cashbacks || [];
            
            const pendingCount = cashbacks.filter(c => 
                c.status === "requested"
            ).length;
            setPendingCount(pendingCount);
        } catch (error) {
            // Only log network errors, not 404s (which are handled above)
            if (error.name !== 'TypeError' || !error.message.includes('404')) {
            console.error('Error fetching cashbacks count:', error);
            }
        }
    };

    useEffect(() => {
        if (user) {
            // Fetch immediately on login
            fetchPendingCount();
            
            // Set up periodic refresh every 10 seconds
            const intervalId = setInterval(fetchPendingCount, 10000);
            return () => clearInterval(intervalId);
        } else {
            // Reset count when user logs out
            setPendingCount(0);
        }
    }, [user]);

    return (
        <CashbacksContext.Provider value={{ pendingCount, setPendingCount }}>
            {children}
        </CashbacksContext.Provider>
    );
};

